import React from "react";
import cpaLogo from "../../images/cpa_logo.png";

export type NavbarIconName =
  | "home"
  | "manage-invoices"
  | "users"
  | "user-search"
  | "calendar"
  | "mail"
  | "monitor"
  | "help-circle"
  | "log-out"
  | "chevron-down"
  | "book-open"
  | "chamber-perks";

type NavbarIconProps = {
  className?: string;
  color?: string;
  isActive?: boolean;
  name: NavbarIconName;
  size?: number;
};

const invoiceIconWhite =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAA7lJREFUeAHtne1t2zAQhl8X/V9vEHWDbBB3gqYT1Jkg2SDuBGkmiLOBN7A3qDtBvEG9AXsX0UHikLIlno+KeA8gGCBlfTwgyNOJtAHDMAzDMAzDMNoyghDOuQl9TNAfNqPRaI6e8BkCkORr+viNnkHXdUayf2Eo0A09uf5yiyFAN1K5/pNd9ieUwSy37FJEM9llJ+HiXccMitD5pu44ssguqUXvyNKySxTNqMsuVTSjKrsE0Y8NdWqySxA9p+2qoV5FdhFdh895ZJVdTB+dW3ZRg2FO2cVFHblkFxne5ZAtko/uOXckbRup4/JxpI5lQyqfXYLoc3RHTHbJT4bHwrIrJGKilTDRSgypj+aBbYM0xogPjnnpS+JfAr7myL1USMS6DiVMtBImWgkTrYR61EEDyw3yj+xbetoLTWFbxfZHbtpGHa4f08eeoIx1HUqYaCVMtBImWokcuY5v+KC4+lF8Gai6j0QxL6iLpgva4GNTBcoOhqvWdShhopUw0UqU8HJWklhffObq5X/7rGlMknl8dwNK/Ieg+xjTdkvb0rWn2h3HWnQDvpU+IBxptCJH9u4Sctk7Xh27CpxjgmY5nL1bNNTzMXim0gx9weXN3i0j55gf+F5j9o7qr50M1e6YFnXs4eXMIIz10e/hLiPWtXEEwUs1NjjuZcDLPib6PZeR8nvaZl3DNRP9ClcPoqHWzPHwDRLIIfoKcsRaF2fS5mj/vdjM0+TZpDmydyucGDrHGt2I9c1dj/eCRR3HUSERE/2WTaT8OxIx0W9ZRcpvaKD8iQRyPIJXkGMbCrfoHAen34be9HAZfXeF8I9wzX1UsoujD16HKG5gj+BUN3Hd+EPbg4s0JOs69vBR0QLt4dBwSttTSLiJDsOxfkpIN6Vt6Syp1Izvb3laxCO6U6GW/TxWmOgILJu2KerWvUI3KtRJqiyP4JycEUv8R8oXaF44dHSE4Jczz303cI7wY/oF4j8XyqFh+upbN/B3hsfio5V/MRfWdQjho5UfkeoLEy2Ilx2KVs5NtDx/A2VjEy3PWajQRAviI5NJoGptomW5i5SvTxlHf3GymTpRDs3TbnntvC9Ljr0Ke0z+jX9/QerLyRLhGU5fm3ZwdWZwAqFzWddxep6Xkpjo03K166KSRfsD5V/C2y+es3+v/55EqkUP5y840mDB7OLr/rQKyT+84RH3Eh+D7aHlanQ/U7yfZsBZx+vA7ivUuevFyd8dlkBKptIGQyVMtBImWgkTrYRY1FEKkRzI1qINoyz+A+kBuR/RGEzxAAAAAElFTkSuQmCC";

const invoiceIconGold =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAABTRJREFUeAHtnUFW20gQhqsE8+LdsJ3FBOsGhsxidnFOMLA0swicAG4Q+wTACcCLiTOrcIN4drMZojmBBcx72Xo3doK6Uq3YL0Zu2cZqt4RV33uJHmrJmJ92dfXf1QJAEARBEARBEITHgmCJu84vdQWqDgWBf7DweeP6EgqCFaHv3r04VqTOoGB4gM2fG9ctKAAeWIBFPoECooCad53dN1AAMgvd69SqfKhCQSmK2FZ6dNEpgtilEFqTt9ibsDKwtd24boIjep3dQw/oYtY1I7EhjwGyND16TF49u3RCa/IQu5RCa1yLvfZCs6DtGW3OxC5Dj75kQY/SGl2JXYrQ4TeC3MUuTYzOW+xSDYZ5il26rCMvsUuZ3uUh9gqn4MXAQzy97ez0TW2E0AeCLVOb7en62gvNQtYovW0mNsUu7cxwUbTYn7557pkQoR0hQjtifWI0qT6PfCFkYyttcMzK2gjtHwRXfLiCDNx0dpv8G5MJy1NGhHaECO0IEdoRzgfDm7e7J4CrGdkXhqC/fXA9VcKmQHU9Q98bVKgPGXGfdSAdQ96VTQgh/z8lNJtNXT50YQVI6HCECO0IEdoRIrQjnA+GbDu+gieKLlH2AD9MNRCem7KYSZwLzSN7CE+b6tSZBdJVCR2OEKEdIUI7Yv0XZ22iOBYbuiYCbOvtf8nz95X7wN8P4um7CD2H3vva1ubAOyagOi+a103XcNshQXSYPF8ZgM8HEXoe8SbVQXTBKWkVMuJc6Nu3L/bYWLLi3kWgwpER9ADOd+sb4FVTbyTsPz/4Z+ayl65UUhA1wRLOhSZUp2DJvdtA7ILBbeNJBX+U6XXqjUghzFhfHO0EboJFJOtIoGd/7Es3wTISoxOw8f8GKCW0IfSVwrbHIUshzF0MGFS+XyNCJ0HaM9XkKaJzqEDT3/+41GqLCD1BnGVQNN2bEQIedDM9WCAP9+4IbBGZP75K0RnHgEtIfxPm+0jVTA/WQKTM1aR5uHddWDH+70EAy5Diwv2gYLnXm0CyjgUYWEhHRegJFMSr41NsoPcbZESEfoDqms4S0cl/f9ZeQwacx+hPnV+rYIlBZdAfu2OTaCOoMqjMnOb/1Pg7TJ7Tqz+3nZ2uyTyKFF7ednbrCF57EzbDRd7HJM6F/gxDveZWBQtsDOMp+NQapDfAM/4+s3pgyP98U0ME1OIpfN3UNnbpPvNVie8HN+92AiQM2H9pmZbrJHQk0FkRIj6+zjrelESH/Evqcc+/6CX2vYjQBqL/1RELt3RKNxL8w6TYIrQB/yjoqyG94iykDcsTlybo8UJ/IUKnoMX2Gx8P9UwWcenCx+rG0Iu3arj3OgjPrZXtkgpNp9kAuvLQC9Pvm++8jdHbmflwGYcBjsP8urXkNTxFf0mUsszFqSH36lbmR2aOqnd60y1unxKWN3pVx0N8b97VhS0JHZbQ2Qp/kvZNbQj0UoS2SGyYGbIVQg45INgF4d+pcxxORGjL6GIa03kR2iI6MTAW2fAKjQhtEbZTT03nETBYXR6N8KNNp842Jvdukse893u4ryqMTjlnrpnaI1Lt1QnNiTo7aIV8UjrMcO/GfIHhRVqtnZH0p9nE1VQSOlbMeCuJCL1CtE8y9qYzCx2/EC7uHZQCXdHEPXnkk8TY+asVKnvdw1rwTeCWekZ+sqzCymDoHwRnvT9qXc/z9uApsIB7F4GusYO/EvdtjfayP4AnKd1IPz75GVylrR1a+8tCZSCLUymDoSNEaEeI0I4QoR0hg+Ej6ZmeU1qBuZVKgrBefAXeCCu8EAV5wAAAAABJRU5ErkJggg==";

export const NavbarIcon: React.FC<NavbarIconProps> = ({
  className,
  color = "currentColor",
  isActive = false,
  name,
  size = 20,
}) => {
  if (name === "manage-invoices") {
    return (
      <img
        aria-hidden="true"
        alt=""
        className={className}
        height={size}
        src={isActive ? invoiceIconGold : invoiceIconWhite}
        width={size}
      />
    );
  }

  if (name === "chamber-perks") {
    return (
      <img
        aria-hidden="true"
        alt=""
        className={className}
        height={size}
        src={cpaLogo}
        width={size}
      />
    );
  }

  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      focusable="false"
      height={size}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      width={size}
    >
      {name === "home" && (
        <>
          <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </>
      )}
      {name === "users" && (
        <>
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </>
      )}
      {name === "user-search" && (
        <>
          <circle cx="10" cy="7" r="4" />
          <path d="M10.3 15H7a4 4 0 0 0-4 4v2" />
          <circle cx="17" cy="17" r="3" />
          <path d="m21 21-1.9-1.9" />
        </>
      )}
      {name === "calendar" && (
        <>
          <path d="M8 2v4" />
          <path d="M16 2v4" />
          <rect height="18" rx="2" width="18" x="3" y="4" />
          <path d="M3 10h18" />
        </>
      )}
      {name === "mail" && (
        <>
          <rect height="16" rx="2" width="20" x="2" y="4" />
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </>
      )}
      {name === "monitor" && (
        <>
          <rect height="14" rx="2" width="20" x="2" y="3" />
          <line x1="8" x2="16" y1="21" y2="21" />
          <line x1="12" x2="12" y1="17" y2="21" />
        </>
      )}
      {name === "help-circle" && (
        <>
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 1 1 5.83 1c0 2-3 3-3 3" />
          <path d="M12 17h.01" />
        </>
      )}
      {name === "log-out" && (
        <>
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" x2="9" y1="12" y2="12" />
        </>
      )}
      {name === "chevron-down" && <path d="m6 9 6 6 6-6" />}
      {name === "book-open" && (
        <>
          <path d="M2 4h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2z" />
          <path d="M22 4h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7z" />
        </>
      )}
    </svg>
  );
};
